export const MISCHIEVOUS_BANJO = 'mischievousBanjo'
